import { Component, OnInit } from '@angular/core';
import { AlertService, ApiService } from '../../../_services';
import { Member } from '../../../_models';

@Component({
  selector: 'app-tm-life',
  templateUrl: './tm-life.component.html',
  styleUrls: ['./tm-life.component.scss']
})
export class TmLifeComponent implements OnInit {

  currentMember: Member;
  constructor(private apiService: ApiService,
    private alertService: AlertService
    ) {
    this.currentMember =  JSON.parse(localStorage.getItem("currentMember"));
   }
  ngOnInit() {
  }

  login(){
    if(this.currentMember.memberSSOProviderStatuses.length > 0 && this.currentMember.memberSSOProviderStatuses[0].status == 0)
    {
        this.alertService.error("Please contact support at 1-866-500-7065");
        $('html, body').animate({
            scrollTop: ($('ng2-toasty').first().offset().top)
        },500);
        return;
    }
    this.apiService.ssoLogin(this.currentMember.memberId, this.currentMember.currentProductId).subscribe(r=>{
        //window.location.href = r.redirectSSOUrl;
        top.window.open( r.redirectSSOUrl, '_blank');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/home/benefits/tm-life/tm-life.component.ts